import {ThunkAction} from 'redux-thunk';
import {AppState} from '..';
import {AnyAction} from 'redux';

export type AppThunk<R = void> = ThunkAction<R | Promise<R>, AppState, unknown, AnyAction>;

export enum AppActions {
  Reset = '@@eskmo/reset',
}
